import { lazy, Suspense } from 'react';
import { ArrowBackIcon } from '@/components/icons';
import { useAppStore, type IAppStore } from '@/store';
import { useResultOverlayStyles } from './styles';

const Loading = lazy(() => import('@/components/Loading'));
const Result = lazy(() => import('@/components/Result'));

// External selector for stable reference
const selector = (store: IAppStore) => store.screen;

interface ResultOverlayProps {
  onClose: () => void;
}

export const ResultOverlay = ({ onClose }: ResultOverlayProps) => {
  const screen = useAppStore(selector);
  const classes = useResultOverlayStyles();

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') onClose();
  };

  return (
    <div className={classes.fullScreenOverlay}>
      <div
        className={classes.overlayHeader}
        onClick={onClose}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
      >
        <ArrowBackIcon className={classes.backIcon} />
        {screen === 'loading' ? 'Generating...' : 'View All Generations'}
      </div>
      <div className={classes.overlayContent}>
        <Suspense fallback={null}>
          {screen === 'loading' ? <Loading /> : <Result />}
        </Suspense>
      </div>
    </div>
  );
};
